import React, { useState } from "react";
import { Box, Paper, Typography, Alert } from "@mui/material";
import PreviewHeader from "./PreviewHeader";
import { STYLE_THEMES } from "../styles/biodataStyles";
import { LANG } from "./utils/languageConfig";

function PreviewSection({
  pages,
  selectedBg,
  profileImage,
  formatDate,
  formatTime,
  generatePdf,
  handleImageUpload,
  selectedReligionLogo,
  coverImage,
  name: biodataName,
  isPdfMode,
  themeType,
  language,
}) {
  const [error, setError] = useState("");
 const activeTheme = STYLE_THEMES[themeType || "light"];

  // 🔥 IMPORTANT: this will be toggled during PDF generation later

  return (
    <>
      <PreviewHeader />

      <Paper sx={{ height: "100%", p: 1 }}>
        <Box
          id="pdf-preview"
          sx={{
            flex: 1,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pb: 0,
          }}
        >
          {error && (
            <Box sx={{ width: "100%", mb: 1 }}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}

          {/* ================= COVER PAGE ================= */}
          {coverImage && (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  zoom: isPdfMode
                    ? "100%"
                    : { xs: "75%", sm: "85%", md: "90%" },
                }}
              >
                <Paper
                  className="pdf-page"
                  sx={{
                    width: "794px",
                    height: "1123px",
                    boxSizing: "border-box",
                    backgroundImage: `url(${selectedBg})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    position: "relative",
                    color: activeTheme.textColor,

                    border: isPdfMode ? "none" : "3px solid #FF9966",
                    boxShadow: isPdfMode
                      ? "none"
                      : "0 0 25px rgba(255,153,102,0.45)",

                    boxShadow: selectedBg
                      ? "0 0 25px rgba(255,153,102,0.45)"
                      : "0 4px 10px rgba(0,0,0,0.08)",
                  }}
                >
                  {/* IMAGE */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -60%)",
                      width: "300px",
                      height: "420px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "16px",
                      padding: "10px",
                      background:
                        "linear-gradient(135deg, rgba(255,255,255,0.6), rgba(255,240,230,0.4))",
                      boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
                    }}
                  >
                    <img
                      src={coverImage}
                      alt="cover"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        borderRadius: "12px",
                      }}
                    />
                  </Box>

                  {/* NAME */}
                  {biodataName && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "68%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          px: 5,
                          py: 1.5,
                          borderRadius: "30px",
                          background:
                            "linear-gradient(135deg, rgba(255,255,255,0.85), rgba(255,240,230,0.75))",
                          border: "2px solid rgba(255,153,102,0.6)",
                          boxShadow: "0 8px 25px rgba(255,153,102,0.35)",
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <Box
                          sx={{
                            width: 30,
                            height: "2px",
                            background: "linear-gradient(90deg,#FF9966,#FF5E62)",
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "26px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            color: "#2C2C2C",
                          }}
                        >
                          {biodataName}
                        </Typography>
                        <Box
                          sx={{
                            width: 30,
                            height: "2px",
                            background: "linear-gradient(90deg,#FF5E62,#FF9966)",
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                    {/* ===== BRAND FOOTER ===== */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: "35px",
                      left: 0,
                      right: 0,
                      textAlign: "center",
                      fontSize: "12px",
                      color: "#888",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {/* Divider */}
                    <Box
                      sx={{
                        width: "60%",
                        height: "1px",
                        background: "rgba(0,0,0,0.08)",
                        margin: "0 auto 6px auto",
                      }}
                    />

                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      Created with{" "}
                      <span style={{ fontWeight: 700, color: "#FF5E62" }}>
                        MarriageBiodata.live
                      </span>
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            </Box>
          )}

          {/* ================= BIODATA PAGES ================= */}
          {pages.map((page, pi) => (
            <Box
              key={pi}
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  zoom: isPdfMode
                    ? "100%"
                    : { xs: "75%", sm: "85%", md: "90%" },
                }}
              >
                <Paper
                  className="pdf-page"
                  sx={{
                    width: "794px",
                    height: "1123px",
                    boxSizing: "border-box",
                    backgroundImage: `url(${selectedBg})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    position: "relative",
                  }}
                >
                  {/* RELIGION */}
                  {selectedReligionLogo && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "37px",
                        left: 0,
                        right: 0,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={selectedReligionLogo.src}
                        alt="Religion"
                        style={{ width: "90px", height: "90px" }}
                      />
                    </Box>
                  )}

                  {/* PHOTO */}
                  {pi === 0 && profileImage && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "165px",
                        right: "80px",
                        width: "120px",
                        aspectRatio: "4 / 5",
                        border: "1px solid #ccc",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={profileImage}
                        alt="Profile"
                        style={{ width: "100%", height: "100%", objectFit: "contain" }}
                      />
                    </Box>
                  )}

                  {/* CONTENT */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "115px",
                      left: "95px",
                      right: "110px",
                    }}
                  >
                    {page
                      .filter((r) => {
                        const langConfig = LANG[language]?.fields;

                        if (!langConfig) return true;

                        if (langConfig.exclude?.includes(r.label)) return false;

                        if (langConfig.include?.length > 0) {
                          return langConfig.include.includes(r.label);
                        }

                        return true;
                      })
                      .map((r, i) =>
                      r.type === "group" ? (
                        <Typography
                          key={i}
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: activeTheme.groupColor,
                            mt: "14px",
                          }}
                        >
                          {LANG[language]?.groups?.[r.text] || r.text}
                        </Typography>
                      ) : (
                        <Box
                          key={i}
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                            mt: "6px",
                          }}
                        >
                          {/* LABEL */}
                          <Box
                            sx={{
                              width: "210px",
                              color: activeTheme.labelColor,
                              flexShrink: 0,
                              fontSize: "16px",
                              lineHeight: "22px",
                            }}
                          >
                           {LANG[language]?.labels[r.label] || r.label}:
                          </Box>

                          {/* VALUE (FIXED OVERLAP) */}
                          <Box
                            sx={{
                              flex: 1,
                              fontSize: "16px",
                              lineHeight: "22px",

                              whiteSpace: isPdfMode ? "normal" : "normal",
                              wordBreak: "break-word",
                              overflowWrap: "anywhere",

                              letterSpacing: isPdfMode ? "0.3px" : "normal",
                              wordSpacing: isPdfMode ? "1px" : "normal",

                              color: r.value
                                  ? activeTheme.valueColor
                                  : activeTheme.placeholderColor,
                            }}
                          >
                            {r.label === "Date Of Birth"
                              ? formatDate(r.value)
                              : r.label === "Time Of Birth"
                              ? formatTime(r.value)
                              : (LANG[language]?.optionsMap?.[r.value] || r.value || "-")}
                          </Box>
                        </Box>
                      )
                    )}
                  </Box>
                  {/* ===== BRAND FOOTER ===== */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: "35px",
                      left: 0,
                      right: 0,
                      textAlign: "center",
                      fontSize: "12px",
                      color: "#888",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {/* Divider */}
                    <Box
                      sx={{
                        width: "60%",
                        height: "1px",
                        background: "rgba(0,0,0,0.08)",
                        margin: "0 auto 6px auto",
                      }}
                    />

                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      Created with{" "}
                      <span style={{ fontWeight: 700, color: "#FF5E62" }}>
                        MarriageBiodata.live
                      </span>
                    </Typography>
                  </Box>
                </Paper>
              </Box>

            </Box>
            
          ))}
          
        </Box>
      </Paper>
    </>
  );
}

export default PreviewSection;